import * as DrupalModel from '../../../api/drupal/drupalTypes'
import { setCookie } from "../../../utils/cookies"

export const PREF_BRANCH_COOKIE = "preferred-branch"
export const PREF_BRANCH_COOKIE_TOAST = "preferred-branch-show-toast"

export const confirmLocation = (locationId: string, branchLocations: DrupalModel.Location[]) => {
  if (locationId == undefined) return
  const preferredBranch = branchLocations.find((loc) => loc.id == locationId)
  setCookie(PREF_BRANCH_COOKIE, locationId, 1000)
  setCookie(PREF_BRANCH_COOKIE_TOAST, 'true', 1)
  //add datalayer push
  window.location.reload();
}

export const toggleLocationDropdown = (dropdownOpen: 'true' | 'false') => {
  const trigger: HTMLElement = document.querySelector('#a11y-location-toggler')
  const target: HTMLElement = document.querySelector('#a11y-location-dropdown')
  const closeTrigger: HTMLElement = document.querySelector('#a11y-location-close')
  if (trigger == null || target == null || closeTrigger == null) {
    return
  }

  if (dropdownOpen == 'true') {
    trigger.setAttribute('aria-expanded', 'false')
    closeTrigger.setAttribute('aria-expanded', 'false')
    target.setAttribute('aria-hidden', 'true')
  } else {
    trigger.setAttribute('aria-expanded', 'true')
    closeTrigger.setAttribute('aria-expanded', 'true')
    target.setAttribute('aria-hidden', 'false')
  }
}
